import { CPARS_AWARD_VALUE } from '../constants/assetFields';

const CURRENCY_FIELDS = [CPARS_AWARD_VALUE];

const isCurrencyFilter = (filterId) => CURRENCY_FIELDS.includes(filterId);

export default isCurrencyFilter;
